import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TeachingAidsMain from './components/TeachingAidsMain';
import './index.css';

/**
 * Main App Component
 * 
 * Root component for A2A Teaching Aids System
 * Provides routing and global layout
 */
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<TeachingAidsMain />} />
      </Routes>
    </Router>
  );
}

export default App;

